import React from "react";
import GrievanceTotal from "../../assets/images/total.png";
import GrievancePending from "../../assets/images/pending.png";
import GrievanceClosed from "../../assets/images/closed.png";

const DashboardStatusCard = ({ dashboardData }) => {
  return (
    <div className="flex justify-between text-center text-white ">
      <div className="w-[31%] flex flex-col bg-gradient-to-r from-[#8CB8F9] to-[#6494DE] rounded-md ">
        <div className="m-3 flex">
          <div className="w-[60px] h-[60px] rounded-full overflow-hidden">
            <img
              className="w-full h-full object-cover "
              src={GrievanceTotal}
              alt="total"
            />
          </div>
          <div className="w-[70%] flex justify-center items-center text-xl ">
            {dashboardData.total || 0}
          </div>
        </div>
        <hr />
        <p className="p-3">Total User Queries Registered</p>
      </div>
      <div className="w-[31%] flex flex-col bg-gradient-to-r from-[#4C9F50] to-[#126C17] rounded-md ">
        <div className="m-3 flex">
          <div className="w-[60px] h-[60px] rounded-full overflow-hidden">
            <img
              className="w-full h-full object-cover "
              src={GrievanceClosed}
              alt="total"
            />
          </div>
          <div className="w-[70%] flex justify-center items-center text-xl ">
            {dashboardData.closed || 0}
          </div>
        </div>
        <hr />
        <p className="p-3">Number of User Queries Closed</p>
      </div>
      <div className="w-[31%] flex flex-col bg-gradient-to-r from-[#EECA46] to-[#E8B522] rounded-md ">
        <div className="m-3 flex">
          <div className="w-[60px] h-[60px] rounded-full overflow-hidden">
            <img
              className="w-full h-full object-cover "
              src={GrievancePending}
              alt="total"
            />
          </div>
          <div className="w-[70%] flex justify-center items-center text-xl ">
            {dashboardData.pending || 0}
          </div>
        </div>
        <hr />
        <p className="p-3">Number of User Queries Pending</p>
      </div>
    </div>
  );
};

export default DashboardStatusCard;
